import React from "react";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-black text-black dark:text-white p-6 max-w-4xl mx-auto">
      <Helmet>
        <title>Privacy Policy - Anime Forever Tamil</title>
        <meta name="description" content="Privacy policy for Anime Forever Tamil. Learn how we handle user data and third-party video embeds." />
        <link rel="canonical" href={window.location.origin + window.location.pathname} />
      </Helmet>
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4 text-sm text-gray-600 dark:text-gray-400">
        Last updated: {new Date().toLocaleDateString()}
      </p>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
        <p className="mb-3">
          Welcome to Anime Forever Tamil ("we," "our," or "us"). This Privacy Policy explains how we collect,
          use, and protect your information when you use our application.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">2. Information We Collect</h2>
        <p className="mb-3">
          Our application provides access to YouTube videos through YouTube's official embed player.
          We collect minimal information necessary for the app to function:
        </p>
        <ul className="list-disc ml-6 mb-3">
          <li>Video viewing preferences (stored locally on your device)</li>
          <li>Like/favorite data (stored in our Supabase database)</li>
          <li>View counts for analytics purposes</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">3. YouTube Services</h2>
        <p className="mb-3">
          This application uses YouTube's embedded player to display video content. When you watch videos,
          you are also subject to YouTube's Terms of Service and Google's Privacy Policy:
        </p>
        <ul className="list-disc ml-6 mb-3">
          <li>
            <a
              href="https://www.youtube.com/t/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              YouTube Terms of Service
            </a>
          </li>
          <li>
            <a
              href="https://policies.google.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 dark:text-blue-400 underline"
            >
              Google Privacy Policy
            </a>
          </li>
        </ul>
        <p className="mb-3">
          We use YouTube's privacy-enhanced mode (youtube-nocookie.com) to minimize data collection.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">4. Data Storage</h2>
        <p className="mb-3">
          We use Supabase (PostgreSQL) to store:
        </p>
        <ul className="list-disc ml-6 mb-3">
          <li>Video metadata (title, thumbnail, description)</li>
          <li>View counts and like counts</li>
          <li>User preferences (stored locally in browser storage)</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">5. Third-Party Services</h2>
        <p className="mb-3">Our app uses the following third-party services:</p>
        <ul className="list-disc ml-6 mb-3">
          <li>YouTube (for video playback)</li>
          <li>Firebase (for data storage and analytics)</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">6. Data Security</h2>
        <p className="mb-3">
          We implement appropriate security measures to protect your information. However, no method
          of transmission over the internet is 100% secure.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">7. Children's Privacy</h2>
        <p className="mb-3">
          Our service is intended for general audiences. We do not knowingly collect personal
          information from children under 13. If you are a parent or guardian and believe your
          child has provided us with personal information, please contact us.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">8. Your Rights</h2>
        <p className="mb-3">You have the right to:</p>
        <ul className="list-disc ml-6 mb-3">
          <li>Access your data</li>
          <li>Request deletion of your data</li>
          <li>Opt-out of data collection (by not using the app)</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">9. Changes to This Policy</h2>
        <p className="mb-3">
          We may update this Privacy Policy from time to time. We will notify you of any changes
          by updating the "Last updated" date at the top of this policy.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">10. Contact Us</h2>
        <p className="mb-3">
          If you have questions about this Privacy Policy, please contact us at:
          <br />
          <span className="font-semibold">Email:</span> [Your Contact Email]
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">11. Content Disclaimer</h2>
        <p className="mb-3">
          All video content is hosted by YouTube. We do not host, store, or own any video content.
          We simply provide an interface to access publicly available YouTube videos. All content
          rights belong to their respective copyright owners.
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
